<template>
    <div class="insurance_container">
        <div v-for="i in 13" :key="i" class="insurance">
            <div class="bloc-title" @click="collapsedOffers[i] = !collapsedOffers[i]">
                <p>#{{ i }}&nbsp;&nbsp;&nbsp;{{ $t('insurance-faq.bloc-title-' + i) }}</p>
                <a
                    :class="[
                        'collapse-button',
                        isVisible(i) ? 'rotate-close' : 'rotate-open',
                    ]"
                >
                    <i class="material-icons arrow-down-icon">keyboard_arrow_down</i>
                </a>
            </div>
            <div :class="[isVisible(i) ? 'collapse-open' : 'collapse-close', 'collapsible-details', 'bloc-description']" v-html="'<p>'+$t('insurance-faq.bloc-description-' + i)+'</p>'" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
            largeScreen: document.documentElement.clientWidth >= 768,
            collapsedOffers: {},
        };
    },
    computed: {
    },
    mounted() {
        for (let i = 1; i <= 13; i++) {
            this.$set(this.collapsedOffers, i, !this.collapsedOffers[i]);
        };
    },
    methods: {
        isVisible(index) {
            return !this.collapsedOffers[index];
        },
    }
};
</script>
<style lang="scss">
@import "~styles/_variables";
.insurance_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 50px;
    margin-left: auto;
    margin-right: auto;
    .insurance {
        width: 100%;
        border: 1px solid $primary-color;
        border-radius: 6px;
        padding: 16px;
        margin-bottom: 16px;
        -webkit-box-shadow: 2px 5px 14px -4px rgba(0,0,0,0.53); 
        box-shadow: 2px 5px 14px -4px rgba(0,0,0,0.53);
        .bloc-title {
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            p {
                margin: 0;
                display: flex;
                align-items: center;
            }
            .collapse-button {
                display: flex;
                justify-content: center;
                align-content: center;
                
                width: 30px;
                height: 30px;
                background-color: white;
                border-radius: 50%;

                transition: 0.4s ease-in-out 0s;;

                .arrow-down-icon {
                    font-size: 30px;
                    margin: auto;
                }
            }

            
            .rotate-open {
                transform: rotate(0deg);
            }
            .rotate-close {
                transform: rotate(180deg);
            }
        }
        .bloc-description {
            font-size: 14px;
            line-height: 24px;
            .insurance-button {
                display: inline-flex;
                align-items: center;
                padding: 0 10px;
                margin-left: 0;
                margin-top: 0;
            }
        }            
        .collapsible-details {
            display: flex;
            overflow: hidden;
            transition: all 0.4s ease-in-out 0s;
        }
        .collapse-open {
            max-height: 300px;
        }

        .collapse-close {
            max-height: 0px;
        }
    }
    .testimonial {
        color: $primary-color;
        font-size: 26px;
        font-weight: bold;
        line-height: 40px;
        text-align: center;
        margin-bottom: 20px;
        @media (max-width: 1024px) {
            font-size: 16px;
            line-height: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/InsuranceFaq.vue